import { type SxProps, Typography } from '@mui/material'
import type { Theme } from '@mui/material/styles'

export function SidebarTypoButton(props: {
  onClick: ((e: React.MouseEvent<HTMLElement>) => void) | undefined
  text: string
  sx?: SxProps<Theme>
}) {
  return (
    <Typography
      className="sidebarTypoButton"
      sx={{
        ml: 'auto',
        color: (theme) => theme.palette.grey[600],
        '&:hover': {
          color: (theme) =>
            theme.palette.mode === 'light'
              ? theme.palette.primary.light
              : theme.palette.primary.contrastText,
        },
        ...(props.sx ?? {}),
      }}
      onClick={props.onClick}
    >
      {props.text}
    </Typography>
  )
}
